import { render, staticRenderFns } from "./WhatsappCallButton.vue?vue&type=template&id=6ef1de88&scoped=true&"
import script from "./WhatsappCallButton.vue?vue&type=script&lang=js&"
export * from "./WhatsappCallButton.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappCallButton.vue?vue&type=style&index=0&id=6ef1de88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1de88",
  null
  
)

export default component.exports